import React, { useEffect, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/DataView/DataViewDemo.css";
import "../../../assets/DataView/index.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../../assets/logo1.png";
import { FilterMatchMode} from 'primereact/api';
import { getUserRole } from "../../../services/userMasterUser";
import { errorMessage } from "../../../utils/alertMessage";
import { formatDate } from "../../../constants/FormateDate";
import { replaceUnderscoresWithSpaces } from "../../../components/Regex";

export default function RoleList() {

  const navigate = useNavigate();

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  const [filters, setFilters] = useState({
          id: { value: null, matchMode: FilterMatchMode.CONTAINS },
          roleName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          roleCode: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          createdDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      });

  const [globalFilterValue, setGlobalFilterValue] = useState('');

  
  
    const fetchData = () => {
      getUserRole()
        .then((response) => {
          if (!response.data.error) {
            setProducts(response.data)
          } else {
            errorMessage("Invalid Credentials");
          }
        })
        .catch((err) => {
          errorMessage();
        })
        .finally(() => console.log(false));
    };

  useEffect(() => {
    fetchData()
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    let _filters = { ...filters };
    _filters['global'] = { value, matchMode: FilterMatchMode.CONTAINS };

    setFilters(_filters);
    setGlobalFilterValue(value)
  };

  const downloadPDF = (data, type) => {
    const doc = new jsPDF("landScape");
    const logoImg = new Image();
    logoImg.src = logoBig;

    doc.addImage(logoImg, "PNG", 10, 5, 50, 15);
    doc.setFontSize(20);
    doc.text("Customer Data", 220, 15);

    doc.autoTable({
      head: [["Name", "Profile", "Auth Person", "Mobile No.", "Email Id"]],
      body: data.map((item) => [
        item.name,
        item.profile,
        item.authorizedPerson,
        item.authorizedPersonMobile,
        item.email,
      ]),
      startY: 25,
      theme: "grid",
      headStyles: {},
      styles: {
        overflow: "linebreak",
        fontSize: 10,
      },
      // columnStyles: {
      //   0: { cellWidth: 60 },
      //   1: { cellWidth: 30 },
      //   2: { cellWidth: 30 },
      //   3: { cellWidth: 30 },
      //   4: { cellWidth: 40 },
      // },
    });

    if (type === "print") {
      // Create blob URL
      const blob = doc.output("blob");
      const blobURL = URL.createObjectURL(blob);

      // Open blob URL in a new window
      const printWindow = window.open(blobURL);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    } else {
      doc.save("Customer-data.pdf");
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/masters")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> User Role List
                </h5>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div>
                    <InputText
                      type="text"
                      value={globalFilterValue} 
                      onChange={onGlobalFilterChange} 
                      placeholder="Search..."
                      // placeholder="Search..."
                      // value={searchQuery}
                      // onChange={handleSearchInputChange}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: 10,
                      // justifyContent: "center",
                      // alignItems: "center",
                    }}
                  >
                    <div className="col-md-2" style={{ alignSelf: "center" }}>
                      <Link
                        to="/user-master/role/create"
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 20,
                          // marginTop: 10,
                        }}
                      >
                        {/*<i
                          onClick={() =>
                            downloadPDF(
                              filteredProducts || products,
                              "download"
                            )
                          }
                          className="pi pi-download"
                          style={{
                            fontSize: "20px",
                            color: "#1e439b",
                            cursor: "pointer",
                          }}
                        ></i>*/}
                        {/*<i
                          onClick={() =>
                            downloadPDF(filteredProducts || products, "print")
                          }
                          className="pi pi-print"
                          style={{
                            fontSize: "20px",
                            color: "#ff0101",
                            cursor: "pointer",
                          }}
                        ></i>*/}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={50}
                      rowsPerPageOptions={[50, 100, 150]}
                      dataKey="id"
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', 'roleName', "roleCode"]}
                      stripedRows 
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      <Column
                        field="createDate"
                        header="Date"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {formatDate(rowData.createdDate)}
                          </span>
                        )}
                      ></Column>
                      
                      <Column
                        field="roleName"
                        header="Role Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.roleName)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="roleCode"
                        header="Role Code"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {replaceUnderscoresWithSpaces(rowData?.roleCode)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.status ? "ACTIVE" : "INACTIVE")}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="Edit"
                        header="Edit"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/user-master/role/edit"}
                            state={rowData}
                            className="move-btn move-btn-yellow center-text"
                          >
                            Edit <i className="bi bi-pencil-square"></i>
                          </Link>
                        )}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
